import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import useSWR from 'swr';

export interface EthereumAPRSummaryInfo {
  aprTotal: string;
  aprProtocol: string;
  aprMev: string;
}
/**
 * useEthereumAPRSummary
 */
export default function useEthereumAPRSummary() {
  return useSWR(
    ['/api/v2/eth2/annualRewardsRate/summary', { days: 30 }],
    ([url, data]) =>
      request.post<ResponseObject<EthereumAPRSummaryInfo>>(url, data),
    {
      refreshInterval: 60_000,
      keepPreviousData: true,
    }
  );
}
